import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment-timezone';

import { getGBDateNow } from '../helpers/dateHelper';
import * as actions from './nonRunners.actions';

import SecondaryNavigation from '../secondaryNavigation';
import Header from './nonRunners.header';
import MetaData from './components/MetaData';
import CourseInfoBlock from './components/CourseInfoBlock';
import LoadingRow from './components/LoadingRow';
import ErrorMessage from './components/ErrorMessage';

export class NonRunners extends PureComponent {
    componentWillReceiveProps({ params: { date: newDate } }) {
        const { date } = this.props.params;
        if (date !== newDate) {
            const requestDate = newDate || moment().tz('Europe/London').format('YYYY-MM-DD');
            this.props.fetchData(requestDate);
        }
    }

    render() {
        const {
            isFetching,
            data: pageData,
            params: {
                date: dateUri,
            },
        } = this.props;
        const date = dateUri ? moment(dateUri) : getGBDateNow();
        const selectedDay = date.format('dddd');
        const titleDate = date.format('D MMMM YYYY');
        const metaDate = date.format('Do MMMM YYYY');
        return (
            <div>
                <MetaData titleDate={titleDate} metaDate={metaDate} />
                <SecondaryNavigation route={dateUri || '/'} />
                <div
                    className="ui-canvas js-contentWrapper"
                    key="canvas"
                >
                    <main className="ui-content ui-content_marginless container">
                        <section>
                            {isFetching
                                ? <LoadingRow />
                                : null}
                            {!isFetching && pageData.length
                                ? <div>
                                    <Header selectedDay={selectedDay} />
                                    {pageData.map(course =>
                                        <CourseInfoBlock
                                            key={course.courseName}
                                            {...course}
                                        />,
                                    )}
                                </div>
                                : null}
                            {!isFetching && !pageData.length && <ErrorMessage />}
                        </section>
                    </main>
                </div>
            </div>
        );
    }
}

NonRunners.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        raceCardsCourseUrl: PropTypes.string,
        raceCardsCourseMeetingsUrl: PropTypes.string,
        courseName: PropTypes.string,
        going: PropTypes.string,
        weather: PropTypes.string,
        stallsPosition: PropTypes.string,
        races: PropTypes.array,
    })).isRequired,
    isFetching: PropTypes.bool.isRequired,
    fetchData: PropTypes.func.isRequired,
    params: PropTypes.shape({
        date: PropTypes.string,
    }).isRequired,
};

function mapStateToProps(state) {
    return {
        data: state.data,
        isFetching: state.isFetching,
    };
}

export default connect(mapStateToProps, {
    fetchData: actions.fetchData,
})(NonRunners);



// WEBPACK FOOTER //
// ./src/js/nonRunners/NonRunners.jsx